<section class="overlay-panel-container news-layout">
  @if (openPanel) {
    <div class="overlay-panel-content" [@slideInRight]>
      <header class="d-flex justify-content-between align-items-center">
        <h5 class="text-primary font-weight-bold"> {{ 'news' | translate }} </h5>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </header>
      <mat-divider></mat-divider>
      <main class="d-flex flex-column overflow-auto h-100 w-100 pb-3">
        <div class="news-container">
          @if (newsList.length == 0) {
            <div style="display: flex; justify-content: center;">
              @if (isLoading) {
                <mat-spinner [diameter]="100"></mat-spinner>
              } @else {
                <div>{{'no.record.found' | translate}}</div>
              }
            </div>
          } @else {
            @for (news of newsList ; track news; let i = $index) {
              <div class="news-holder">
                <span class="news-title py-1">{{news.subject}}</span>
                @if (news.isGlobalNews) {
                  <div class="news-content py-1">
                  {{news.startDate}}</div>
                }
                @if (!news.isGlobalNews) {
                  <div class="news-content py-1">{{ setDate(news.createdDate) |
                  globalDateTime }}</div>
                }
                @if (news.isGlobalNews) {
                  <div class="content-description">
                    <app-avantor-dom-sanitized-container
                    [content]="news.description"></app-avantor-dom-sanitized-container>
                  </div>
                }
                @if (!news.isGlobalNews) {
                  <div class="news-content py-1">{{news.description}}</div>
                }
                <div class="d-flex read-more"
                  [ngStyle]="{'margin-bottom': i+1== newsList.length ? '100px' : '0px'}"
                  (click)="setNewsForRead(news)" routerLink="communications/news-and-updates">
                  Read More <img src="/icons/arrow-double-right.svg" alt="">
                </div>
              </div>
            }
          }
        </div>
      </main>
    </div>
  }
</section>